<template>
    <div>
        <div class="table-responsive">
            <table class="table table-hover table-row-dashed align-middle gs-0 gy-4 my-0">
                <thead class="thead-light">
                <tr class="text-left">
                    <th class="w-3">
                        <TableSort field="rank" :value="sort" @input="updateSort">
                            {{ __('statistics.popularity_rank') }}
                        </TableSort>
                    </th>
                    <th class="max-w-300px">
                        <TableSort field="name" :value="sort" @input="updateSort">
                            {{ __('general.name') }}
                        </TableSort>
                    </th>
                    <th>
                        <TableSort field="category" :value="sort" @input="updateSort">
                            {{ __('statistics.category') }}
                        </TableSort>
                    </th>
                    <th>
                        <TableSort field="ean" :value="sort" @input="updateSort">
                            EAN
                        </TableSort>
                    </th>
                    <th>
                        <TableSort field="min_price" :value="sort" @input="updateSort">
                            {{ __('statistics.price_comparison.comparison_price') }}
                        </TableSort>
                    </th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="singleStatistic in statistics.data" class="text-left">
                    <td class="align-content-center w-3">
                        {{ singleStatistic.rank }}
                    </td>
                    <td class="align-content-center max-w-300px">
                        {{ singleStatistic.name }}
                    </td>
                    <td class="align-content-center">
                        {{ singleStatistic.category_l1 }}
                    </td>
                    <td class="align-content-center">
                        {{ singleStatistic.ean }}
                    </td>
                    <td class="align-content-center">
                        <div class="d-flex justify-content-between align-items-center max-w-160px">
                            <span class="d-flex">{{ singleStatistic.min_price.toFixed(2) }}<CurrencySymbol :currency="singleStatistic.currency"/></span>
                            <span>-</span>
                            <span class="d-flex">{{ singleStatistic.max_price.toFixed(2) }}<CurrencySymbol :currency="singleStatistic.currency"/></span>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <Pagination v-if="lastRow !== maxSearchResults"
                    :pagination="statistics"
                    :inertia-options="{
                            only: ['statistics']
                        }"
                    disable-when-one-page
                    scroll-to-top
        />
    </div>
</template>

<script>
import TableSort from '@components/Table/TableSort.vue';
import Pagination from '@components/TableComponents/Pagination.vue';
import {rewriteUrlNew} from '@composables/rewriteUrlNew';
import CurrencySymbol from '@components/CurrencySymbol.vue';

export default {
    components: {CurrencySymbol, Pagination, TableSort},
    props: {
        statistics: {
            types: [Object, Array],
        },
        category: String,
        maxSearchResults: Number,
    },

    data() {
        return {
            sort: {}
        }
    },

    computed: {
        lastRow() {
            return this.statistics.total;
        },

        perPage() {
            return this.statistics.per_page;
        },

        page() {
            return this.statistics.current_page;
        },
    },

    methods: {
        updateSort(sortParams) {
            this.sort = sortParams;
            rewriteUrlNew('sort', sortParams);
            this.$emit('reloadStats');
        },

        goToFirstPageIfNeeded() {
            if (this.statistics.current_page > this.statistics.last_page) {
                rewriteUrlNew('page', 1);
                rewriteUrlNew('per_page', this.statistics.per_page);
                this.$emit('reloadStats');
            }
        },
    },

    watch: {
        'statistics.last_page'() {
            this.goToFirstPageIfNeeded();
        },
    },
};
</script>
